export default {"src":"/_next/static/media/load-more-light.878e23a3.svg","height":256,"width":256};